import { render, staticRenderFns } from "./PreviewCard.vue?vue&type=template&id=228a32bb"
import script from "./PreviewCard.vue?vue&type=script&lang=js"
export * from "./PreviewCard.vue?vue&type=script&lang=js"
import style0 from "./PreviewCard.vue?vue&type=style&index=0&id=228a32bb&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports